import { createSlice } from "@reduxjs/toolkit";

export const UserRoutes = createSlice({
  name: "UserRoutes",
  initialState: {
    userRoutes: [],
  },
  reducers: {
    setUserRoutes: (state, action) => {
      state.userRoutes = action.payload;
    },
  },
});

export const { setUserRoutes } = UserRoutes.actions;

export default UserRoutes.reducer;
